import { Navigate, createFileRoute } from "@tanstack/react-router";

/** The old Drafts tab: the worlds being built now sit in Simulation's one Worlds list. */
export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds/",
)({ component: BuildWorldsRoute });

function BuildWorldsRoute() {
  return (
    <Navigate
      to="/p/$org/$project/simulate"
      params={Route.useParams()}
      search={{ kind: "building" }}
      replace
    />
  );
}
